import { Address } from 'viem'

export const ENV_PARAMS = {
  MODE: import.meta.env.VITE_MODE,
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  API_TARGET_URL: import.meta.env.VITE_API_TARGET_URL,
  EVM_BRIDGE_ADDRESS: import.meta.env.VITE_EVM_BRIDGE_ADDRESS as Address
}
